<template>
	<div>
		<complete-profile v-if="cat_profile_id == YOUNG_PROFILE_ID"></complete-profile>
		<CompleteAdvisorProfile v-if="cat_profile_id == ADVISOR_PROFILE_ID"></CompleteAdvisorProfile>
		<InstructorHome v-if="cat_profile_id == REPONSIBLE_PROFILE_ID"/>
	</div>
</template>

<script>
	import CompleteProfile from "@/components/views/home/young/register/CompleteProfile";
	import CompleteAdvisorProfile from "@/components/views/home/advisor/CompleteProfile";

	import InstructorHome from "@/components/views/home/instructor/InstructorHome";


	import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';

	export default {
		components: {
			CompleteProfile,
			CompleteAdvisorProfile,
			InstructorHome
		},
		data() {
			const YOUNG_PROFILE_ID = 2;
			const ADVISOR_PROFILE_ID = 3;
			const REPONSIBLE_PROFILE_ID = 4;
			return {
				YOUNG_PROFILE_ID: YOUNG_PROFILE_ID,
				ADVISOR_PROFILE_ID: ADVISOR_PROFILE_ID,
				REPONSIBLE_PROFILE_ID: REPONSIBLE_PROFILE_ID
			};
		},
		computed: {
			...mapGetters(["userFullName", "cat_profile_id", "userEmail"])
		},
	}
</script>

<style scoped>

</style>